// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Refunds_header__2-UC3 {\n    background-color: #2c7ca4;\n    font-weight: bold;\n    color: white;\n    font-size: 20px;\n  }\n  ", "",{"version":3,"sources":["webpack://src/components/Admin/MainWindow/Refunds/Refunds.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,eAAe;EACjB","sourcesContent":[".header {\n    background-color: #2c7ca4;\n    font-weight: bold;\n    color: white;\n    font-size: 20px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "Refunds_header__2-UC3"
};
export default ___CSS_LOADER_EXPORT___;
